import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { Button, Checkbox, Form, Tabs, message } from "antd";
import { cloneDeep, isEmpty } from "lodash";
import React, { useContext, useRef, useState } from "react";
import { UserContext } from "../../../amplify/authenticator-provider";
import { CREATE_CAMPAIGN_SCHEDULES, UPDATE_CAMPAIGN_SCHEDULES } from "../../../graphql/mutation";
import { GET_AI_RESPONSE, GET_USE_CASES } from "../../../graphql/query";
import useLang from "../../../hooks/useLang";
import TemplateDrawer from "../schedual/templateDrawer";
import { handleSaveMessage, removeHtmlTags } from "./commonFunctions";
import { PreviewModal } from "./PreviewModal";
import { TextInputJSX } from "./TextInputJSX";

export const FormJsx = ({
  internalIndex,
  sourceId,
  campaignData,
  index,
  setCampaignData,
  setactiveKeys,
  activeMode,
  setactiveMode,
  isEmail,
  onlyEmail,
  mode,
}) => {
  const [lang] = useLang();
  const [form] = Form.useForm();
  const textRef = useRef(null);
  const afterMessageTextRef = useRef(null);
  const [templateDrawer, settemplateDrawer] = useState({ visible: false });
  const [previewState, setpreviewState] = useState({
    visible: false,
    data: {},
  });
  const [loading, setLoading] = useState(false);
  const [loadingAfterWorkHour, setLoadingAfterWorkHour] = useState(false);
  const { data: useCases } = useQuery(GET_USE_CASES);
  const { user } = useContext(UserContext);
  const [isAfterHour, setIsAfterHour] = useState(false);
  const [messageIndex, setMessageIndex] = useState(null);

  const buildCampaignInput = () => {
    const campaignInput = {
      campaignId: campaignData?.id,
      sourceIds: campaignData?.source?.map(item => item[0]),
      statusIds: campaignData?.status,
      schedules: [],
      startDuration: campaignData?.type,
      messageIndex: index,
      title: campaignData?.title,
      description: "",
      engagementMethod: campaignData?.method,
      startDate: campaignData?.startDate,
      endDate: campaignData?.endDate,
    };
    (campaignData?.messages).forEach((message, index) => {
      campaignInput.schedules.push({
        index: index,
        title: message?.title,
        templateText: message?.campaignTemplates[0]?.templateText,
        repeat: message?.type === "REPEAT",
        numericValue: message?.numericValue,
        temporalValue: message?.temporalValue,
        isAfterHour: message?.isAfterHour,
      });
    });
    return campaignInput;
  };

  const [getAIResponse, { data: aiResponseData }] = useLazyQuery(GET_AI_RESPONSE, {
    fetchPolicy: "network-only",
    onCompleted: res => {
      if (res?.getAiResponse?.statusCode === 200) {
        if (!isAfterHour) {
          textRef.current.value = res?.getAiResponse?.content;
        } else {
          afterMessageTextRef.current.value = res?.getAiResponse?.content;
        }
      } else message.error(lang.ottoAiSuggestionFailedText);

      setLoading(false);
      setLoadingAfterWorkHour(false);
    },
    onError: err => {
      setLoading(false);
      setLoadingAfterWorkHour(false);
    },
  });
  const [createCampaignSchedules, { loading: createCampaignSchedulesLoader }] =
    useMutation(CREATE_CAMPAIGN_SCHEDULES);
  const [updateCampaignSchedules, { loading: updateCampaignSchedulesLoader }] =
    useMutation(UPDATE_CAMPAIGN_SCHEDULES);
  const handleKeyWordAfterTextMessage = text => {
    const elem = document.getElementById("textArea-afterMessage");
    const startPos = elem.selectionEnd;
    const output = [
      afterMessageTextRef.current.value.slice(0, startPos),
      `${text} `,
      afterMessageTextRef.current.value.slice(startPos),
    ].join("");
    setCampaignData(prev => {
      const temp = structuredClone(prev).messages;
      temp[index] = {
        ...temp[index],
        isChanged: true,
      };
      temp[index].campaignTemplates[internalIndex === "all" ? 0 : internalIndex + 1] = {
        ...temp[index].campaignTemplates[internalIndex === "all" ? 0 : internalIndex + 1],
        afterHourTemplateText: output,
      };
      return { ...prev, messages: temp };
    });
    if (afterMessageTextRef.current) {
      afterMessageTextRef.current.focus();
    }
  };

  const saveMessage = async index => {
    if (isEmpty(campaignData.messages[index].title)) {
      message.error("Please enter the title of the message");
      return;
    }
    if (
      campaignData.messages[index].campaignTemplates.length > 0 &&
      !isEmpty(removeHtmlTags(campaignData.messages[index]?.campaignTemplates[0]?.templateText))
    ) {
      // call the createCampaignSchedules
      // const messageObj = { ...campaignData.messages[index], sortOrder: index };
      const messageObj = cloneDeep({ ...campaignData.messages[index], sortOrder: index });
      delete messageObj.createId;
      delete messageObj.isChanged;
      if (campaignData.messages[index].scheduleId) {
        // update Single Campaign Schedule
        const payload = cloneDeep(campaignData.messages[index]);
        delete payload.createId;
        delete payload.isChanged;
        (payload?.campaignTemplates || [])?.forEach(template => {
          // Remove scheduleId property
          delete template?.scheduleId;
        });
        const res = await updateCampaignSchedules({
          variables: { message: { ...payload, sortOrder: index } },
        });
        if (res.data.updateCampaignSchedules.statusCode) {
          setCampaignData(prev => {
            const temp = structuredClone(prev);
            temp.messages[index] = {
              ...temp.messages[index],
              isChanged: false,
            };
            return temp;
          });
          message.success("Message successfully updated");
          return true;
        }
      } else {
        // create Single campaign Schedule
        const res = await createCampaignSchedules({
          variables: {
            campaignId: campaignData.id,
            message: messageObj,
          },
        });
        if (res.data.createCampaignSchedules.statusCode) {
          setCampaignData(prev => {
            const temp = structuredClone(prev);
            temp.messages[index] = {
              ...temp.messages[index],
              scheduleId: res?.data?.createCampaignSchedules?.campaignSchedule?.id,
              isChanged: false,
            };
            return temp;
          });
          message.success("Message successfully created");
          return true;
        }
      }
      return;
    }
    message.error("Please enter the atleast one template text!");
    return false;
  };
  const getTargetobjectBySource = () => {
    const obj = (campaignData?.messages[index]?.campaignTemplates || []).find(
      item => item.sourceId === sourceId
    );
    if (obj) {
      return obj;
    }
    return { sourceId: sourceId };
  };
  const targetObject =
    mode === "ADD"
      ? campaignData?.messages[index]?.campaignTemplates[
          internalIndex === "all" ? 0 : internalIndex + 1
        ]
      : getTargetobjectBySource();
  const [afterHourMode, setafterHourMode] = useState("text");
  console.log(campaignData);
  return (
    <>
      <Form
        onFinish={() => handleSaveMessage(setactiveKeys, index, () => saveMessage(index))}
        form={form}
        className="flex flex-col w-full relative"
      >
        {isEmail ? (
          <Tabs activeKey={activeMode} onChange={activeKey => setactiveMode(activeKey)}>
            <Tabs.TabPane tab="Text" key="text">
              <TextInputJSX
                isEmail={false}
                targetKey="templateText"
                setCampaignData={setCampaignData}
                index={index}
                internalIndex={internalIndex}
                sourceId={sourceId}
                setIsAfterHour={setIsAfterHour}
                setMessageIndex={setMessageIndex}
                setLoading={setLoading}
                getAIResponse={getAIResponse}
                user={user}
                useCases={useCases}
                buildCampaignInput={buildCampaignInput}
                loading={loading}
                campaignData={campaignData}
                setpreviewState={setpreviewState}
                mode={mode}
                targetObject={targetObject}
              />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Email" key="email">
              <TextInputJSX
                isEmail
                targetKey="emailTemplateText"
                setCampaignData={setCampaignData}
                index={index}
                internalIndex={internalIndex}
                sourceId={sourceId}
                setIsAfterHour={setIsAfterHour}
                setMessageIndex={setMessageIndex}
                setLoading={setLoading}
                getAIResponse={getAIResponse}
                user={user}
                useCases={useCases}
                buildCampaignInput={buildCampaignInput}
                loading={loading}
                campaignData={campaignData}
                setpreviewState={setpreviewState}
                mode={mode}
                targetObject={targetObject}
              />
            </Tabs.TabPane>
          </Tabs>
        ) : (
          <TextInputJSX
            isEmail={campaignData?.messages[index]?.messageType === "EMAIL"}
            targetKey={
              campaignData?.messages[index]?.messageType === "EMAIL"
                ? "emailTemplateText"
                : "templateText"
            }
            setCampaignData={setCampaignData}
            index={index}
            internalIndex={internalIndex}
            sourceId={sourceId}
            setIsAfterHour={setIsAfterHour}
            setMessageIndex={setMessageIndex}
            setLoading={setLoading}
            getAIResponse={getAIResponse}
            user={user}
            useCases={useCases}
            buildCampaignInput={buildCampaignInput}
            loading={loading}
            campaignData={campaignData}
            setpreviewState={setpreviewState}
            mode={mode}
            targetObject={targetObject}
          />
        )}
      </Form>
      {index === 0 && (
        <div className="flex flex-col mt-4">
          <div className="flex-row-centered justify-between">
            <Checkbox
              checked={
                campaignData.messages[index].campaignTemplates[
                  internalIndex === "all" ? 0 : internalIndex + 1
                ]?.isAfterHour
              }
              onChange={e =>
                setCampaignData(prev => {
                  const temp = structuredClone(prev).messages;
                  temp[index] = {
                    ...temp[index],
                    isChanged: true,
                  };
                  temp[index].campaignTemplates[internalIndex === "all" ? 0 : internalIndex + 1] = {
                    ...temp[index].campaignTemplates[
                      internalIndex === "all" ? 0 : internalIndex + 1
                    ],
                    isAfterHour: e.target.checked,
                    afterHourTemplateText: "",
                  };
                  return { ...prev, messages: temp };
                })
              }
            >
              After work hours message
            </Checkbox>
            {campaignData.messages[index].campaignTemplates[
              internalIndex === "all" ? 0 : internalIndex + 1
            ]?.isAfterHour && (
              <Button onClick={() => settemplateDrawer({ visible: true })}>Select Template</Button>
            )}
          </div>
          {campaignData.messages[index].campaignTemplates[
            internalIndex === "all" ? 0 : internalIndex + 1
          ]?.isAfterHour ? (
            isEmail ? (
              <Tabs activeKey={afterHourMode} onChange={activeKey => setafterHourMode(activeKey)}>
                <Tabs.TabPane tab="Text" key="text">
                  <TextInputJSX
                    isEmail={false}
                    targetKey="afterHourTemplateText"
                    setCampaignData={setCampaignData}
                    index={index}
                    internalIndex={internalIndex}
                    sourceId={sourceId}
                    setIsAfterHour={setIsAfterHour}
                    setMessageIndex={setMessageIndex}
                    setLoading={setLoading}
                    getAIResponse={getAIResponse}
                    user={user}
                    useCases={useCases}
                    buildCampaignInput={buildCampaignInput}
                    loading={loading}
                    campaignData={campaignData}
                    setpreviewState={setpreviewState}
                    mode={mode}
                    targetObject={targetObject}
                  />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Email" key="email">
                  <TextInputJSX
                    isEmail
                    targetKey="afterHourEmailTemplateText"
                    setCampaignData={setCampaignData}
                    index={index}
                    internalIndex={internalIndex}
                    sourceId={sourceId}
                    setIsAfterHour={setIsAfterHour}
                    setMessageIndex={setMessageIndex}
                    setLoading={setLoading}
                    getAIResponse={getAIResponse}
                    user={user}
                    useCases={useCases}
                    buildCampaignInput={buildCampaignInput}
                    loading={loading}
                    campaignData={campaignData}
                    setpreviewState={setpreviewState}
                    mode={mode}
                    targetObject={targetObject}
                  />
                </Tabs.TabPane>
              </Tabs>
            ) : (
              <TextInputJSX
                isEmail={campaignData?.messages[index]?.messageType === "EMAIL"}
                targetKey={
                  campaignData?.messages[index]?.messageType === "EMAIL"
                    ? "afterHourEmailTemplateText"
                    : "afterHourTemplateText"
                }
                setCampaignData={setCampaignData}
                index={index}
                internalIndex={internalIndex}
                sourceId={sourceId}
                setIsAfterHour={setIsAfterHour}
                setMessageIndex={setMessageIndex}
                setLoading={setLoading}
                getAIResponse={getAIResponse}
                user={user}
                useCases={useCases}
                buildCampaignInput={buildCampaignInput}
                loading={loading}
                campaignData={campaignData}
                setpreviewState={setpreviewState}
                mode={mode}
                targetObject={targetObject}
              />
            )
          ) : null}
        </div>
      )}
      <div className="text-right w-full mt-2">
        <Button
          type="primary"
          loading={createCampaignSchedulesLoader || updateCampaignSchedulesLoader}
          onClick={() => {
            form.submit();
            // handleSaveMessage(setactiveKeys, index, () => saveMessage(index));
          }}
        >
          Save message
        </Button>
      </div>
      {templateDrawer.visible && (
        <TemplateDrawer
          openTemplateDrawer={templateDrawer}
          setOpenTemplateDrawer={settemplateDrawer}
          onApply={textMessage => {
            setCampaignData(prev => {
              const temp = structuredClone(prev).messages;
              temp[index] = {
                ...temp[index],
                isChanged: true,
              };
              if (mode === "ADD") {
                temp[index].campaignTemplates[internalIndex === "all" ? 0 : internalIndex + 1] = {
                  ...temp[index].campaignTemplates[internalIndex === "all" ? 0 : internalIndex + 1],
                  sourceId: sourceId,
                  ...(isEmail
                    ? afterHourMode === "text"
                      ? { afterHourTemplateText: textMessage }
                      : { afterHourEmailTemplateText: textMessage }
                    : onlyEmail
                    ? { afterHourEmailTemplateText: textMessage }
                    : { afterHourTemplateText: textMessage }),
                };
              } else {
                // TODO: Handle this from the edit form
                const objIndex = temp[index].campaignTemplates.findIndex(
                  item => item.sourceId === targetObject.sourceId
                );
                temp[index].campaignTemplates[objIndex] = {
                  ...temp[index].campaignTemplates[objIndex],
                  ...(isEmail
                    ? afterHourMode === "text"
                      ? { afterHourTemplateText: textMessage }
                      : { afterHourEmailTemplateText: textMessage }
                    : onlyEmail
                    ? { afterHourEmailTemplateText: textMessage }
                    : { afterHourTemplateText: textMessage }),
                };
              }
              return { ...prev, messages: temp };
            });
          }}
        />
      )}
      {previewState.visible && (
        <PreviewModal previewState={previewState} setpreviewState={setpreviewState} />
      )}
    </>
  );
};
